import '@/modules/cache-manager';
import * as Sentry from '@sentry/vue';
import { CaptureConsole } from '@sentry/integrations';
import Vue from 'vue';
import './assets/css/tailwind.css';
import Toasted from 'vue-toasted';
import VueScroller from 'vue-scroller';
import VModal from 'vue-js-modal';
import VueGtag from 'vue-gtag';
import LoadingPage from './plugins/LoadingPage';
import i18n from './i18n';
import App from './App.vue';
import $api from './modules/request';
import router from './router';
import store from './store';
import events from './events';
import { VERSION } from './store/modules/app';

Vue.use(
  VueGtag,
  {
    config: { id: 'G-VP9ZMTMYV9' },
  },
  router
);

Vue.use(VueScroller);

/**
 * Setup Toasted
 */
Vue.use(Toasted, {
  position: 'bottom-center',
  duration: 5000,
  keepOnHover: true,
  singleton: true,
  containerClass: 'cloudzet-toaster-container',
  className: 'cloudzet-toaster',
});
Vue.toasted.register('alert', message => message || i18n.t('welcome.unexpected_error'), {
  type: 'error',
});

/**
 * Setup vue-js-modal
 */
Vue.use(VModal, {
  dynamicDefaults: {
    adaptive: true,
    height: 'auto',
    width: '90%',
    maxWidth: 550,
    minWidth: 200,
  },
});

/**
 * Custom plugins
 */
Vue.use(LoadingPage);

events.setup();

Vue.config.productionTip = false;
Vue.prototype.$events = events;
Vue.prototype.$api = $api;

window.TG3DCloudzetEvents = events;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');

Sentry.init({
  dsn:
    'https://3a46fbc017b235d77cb77e40585097b6@o4506097550098432.ingest.sentry.io/4506097555210240',
  release: `cloudzet-web@${VERSION}`,
  integrations: [
    new Sentry.Replay(),
    new CaptureConsole({
      levels: ['error'],
    }),
  ],
  beforeSend(event) {
    if (event.tags && event.tags.source === 'api') {
      if (
        typeof event.tags.api_endpoint === 'string' &&
        event.tags.api_endpoint.includes('size_xt?version=4&pose=I') &&
        event.tags.api_status === 404
      ) {
        return null;
      }
    }
    return event;
  },
  // Session Replay
  replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 0.1, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});
